import DamilarePhoto from "../assets/images/team/damilare-mh-team.jpeg";
import AdemolaPhoto from "../assets/images/team/ceo-ademola.jpeg";
import RukemePhoto from "../assets/images/team/rukeme-mh-team.jpeg";
import GideonPhoto from "../assets/images/team/gideon-mh-team.jpeg";
import PaulPhoto from "../assets/images/team/paul-mh-team.jpeg";
import RuthPhoto from "../assets/images/team/ruth-mh-team.jpeg";
import PraisesPhoto from  "../assets/images/team/praises-mh-team.jpeg";
import SundayPhoto from "../assets/images/team/sunday-mh-team.jpeg";


export const teams = [
  {
    photo: AdemolaPhoto,
    name: "Ademola Adeosun",
    title: "Managing Director / CEO",
    details:
    `Ademola Adeosun is the Founder and CEO of Mosun Homes and Realtors Limited. With over 7 years experience in the real estate sector, Ademola sits on the executive board of the firm over-seeing business model and growth.Over the years, Ademola has acquired deep knowledge and excellent understanding of various aspects of the real estate business in a variety of roles and responsibilities, from structing investment funds vehicles for the purpose of developing and investing in valuable real estate assets, creating value and returns for limited partners. Ademola brings integrity, a sound business head and a wealth of invaluable leadership experience and capabilities to the Nigerian Real Estate Industry. In his role as the CEO/Managing Director of Mosun Homes and Realtors, he leads the company's drive towards the attainment of a sustainable successful integrated real estate business including Environmental, Social and Governance initiatives and programs. `,
  },

  {
    photo: DamilarePhoto,
    name: "Dami Oludare",
    title: "Director Growth and Strategy",
    details:
      `Dami oversees strategy and business growth for the company. His experience is rooted in real estate deals advisory working on innovative and complex transactions for clients across residential and commercial asset classes.`,
  },

  {
    photo: RukemePhoto,
    name: "Rukeme Taire",
    title: "Sales and Leasing Associate",
    details:
      `Rukeme is a seasoned real estate sales head highly skilled in property negotiations, acquisition and management. With almost 5 years of experience, she has closed multimillion naira deals in the Real estate business including rental and investment properties. Kindly get in touch for your property acquisitions at strategic locations.`,
  },

  {
    photo: GideonPhoto,
    name: "Gideon Philip",
    title: "Chief Financial Officer",
    details:
      `Gideon is an experienced Accounting and Finance professional with over 5 years of cognate experience in budgeting and budgetary control, financial reporting, financial analysis, financial strategy and tax management across different industries. He is adept in the installation of internal control and suitable accounting systems. `,
  },

  {
    photo: PraisesPhoto,
    name: "Praises Ero-Philips",
    title: "Lead, Human Resources & Administration",
    details:
      `Praises is an HR and Admin professional with experience in people management, talent acquisition, employee relations, and organizational operations. An Economics graduate and Associate of the Chartered Institute of Personnel Management of Nigeria (CIPM), she is passionate about building effective people systems, strengthening workplace culture, and driving organizational growth through people. `,
  },

  {
    photo: SundayPhoto,
    name: "Sunday Okhuoya Eragbai",
    title: "Legal Counsel",
    details:
      `Sunday Okhuoya Eragbai, Esq. is a legal practitioner with experience in corporate practice, litigation, compliance, contract drafting and review, negotiation, and dispute resolution across law firms and corporate organisations. He brings strong research, drafting, analytical, and negotiation skills, applying legal expertise to practical business needs. He is an Associate of the Institute of Chartered Mediators and Conciliators (AICMC), with interests in corporate/commercial law, regulatory compliance, and dispute resolution. `,
  },

  {
    photo: PaulPhoto,
    name: "Paul Olagunju",
    title: "Facility Manager",
    details:
      `Paul is an experienced Real Estate professional with over six (6) years experience in facility management, letting, sales, feasibility/viability appraisal and Valuation.`,
  },

  {
    photo: RuthPhoto,
    name: "Ruth Ayobi",
    title: "Finance Associate",
    details:
      `Ruth Ayobi is a detail-oriented Finance Associate with proven expertise in preparing and maintaining financial records, while ensuring strict adherence to internal controls and regulatory standards. She brings hands-on experience in supporting financial operations and compliance processes. Ruth is also passionate about monitoring economic trends and effectively translating these insights into informed financial decisions.`,
  },
];